import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { priceService } from "../../Api/priceService";

const initialState = {
  fiat_price: [],
  crypto_price: [],
  isLoading: false,
  isSuccess: false,
  isError: false,
  error: null,
};

export const getCryptoPrice = createAsyncThunk(
  "get/crypto_price",
  async (_, thunkAPI) => {
    try {
      return await priceService.getCryptoPrice();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getFiatPrice = createAsyncThunk(
  "get/fiat_price",
  async (_, thunkAPI) => {
    try {
      return await priceService.getFiatPrice();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const priceSlice = createSlice({
  name: "price",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getFiatPrice.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(getFiatPrice.fulfilled, (state, action) => {
        state.fiat_price = action?.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(getFiatPrice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error =
          action?.payload?.code === "ERR_NETWORK"
            ? action?.payload?.message
            : action?.payload?.response?.data?.message;
      })
      .addCase(getCryptoPrice.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(getCryptoPrice.fulfilled, (state, action) => {
        state.crypto_price = action?.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(getCryptoPrice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error =
          action?.payload?.code === "ERR_NETWORK"
            ? action?.payload?.message
            : action?.payload?.response?.data?.message;
      });
  },
});

export default priceSlice.reducer;
